// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d53084f3","455":"75799ff1"}[chunkId] + ".chunk.js";
};